import { bookDb } from '@/db/book';
import type { Book } from '@/db/schema';
import { useLiveQuery } from 'dexie-react-hooks';
import { Link, useParams } from 'react-router-dom';

export function BookInfo() {
    const { bookId } = useParams();
    const book = useLiveQuery<Book | undefined>(() => bookDb.books.get(bookId ?? ''), [bookId]);

    if (!book) return <div>Loading...</div>;
    if (!bookId) return <div>No bookId provided</div>;

    return (
        <div className="flex flex-col max-h-[100vh] overflow-y-auto">
            <h1 className="text-[38px] font-bold">{book.bookName} Book</h1>
            <div className="m-2 flex flex-col rounded-md border p-2 text-left">
                <div>
                    <h2 className="font-bold">ZyTags:</h2>
                    <ul className="flex flex-wrap">
                        {book.children.zytags.map(tag => (
                            <li
                                key={tag}
                                className="m-2 w-fit rounded-md bg-orange-100 p-1"
                            >
                                <Link to={`/search/tag/${tag}`}>
                                    <span className="font-bold">{`<${tag}>`}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="m-2 flex flex-col rounded-md border p-2 text-left">
                <div>
                    <h2 className="font-bold">HTML Tags:</h2>
                    <ul className="flex flex-wrap">
                        {book.children.htmlTags.map(tag => (
                            <li
                                key={tag}
                                className="m-2 w-fit rounded-md bg-blue-100 p-1"
                            >
                                <Link to={`/search/tag/${tag}`}>
                                    <span className="font-bold">{`<${tag}>`}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="m-2 flex flex-col rounded-md border p-2 text-left">
                <h2 className="font-bold">Google Docs:</h2>
                <ul className="flex flex-wrap">
                    {book.gdocs.map(gdoc => (
                        <li
                            key={gdoc}
                            className="m-2 w-fit rounded-md bg-green-100 p-1"
                        >
                            <a
                                href={`https://docs.google.com/document/d/${gdoc}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {gdoc}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
